import { CardDescription } from "@/types";
import * as S from "./styles";
import { useGlobals } from "@/hooks";

const ContentItem = () => {
  const { cardDescription, setCardDescription } = useGlobals();

  return (
    <S.DirectionControl>
      <S.ButtonDirection
        $active={cardDescription === CardDescription.DE}
        data-test="filter-bar-list-button"
        onClick={() => setCardDescription(CardDescription.DE)}
      >
        {CardDescription.DE}
      </S.ButtonDirection>

      <S.ButtonDirection
        $active={cardDescription === CardDescription.DC}
        data-test="filter-bar-grid-button"
        onClick={() => setCardDescription(CardDescription.DC)}
      >
        {CardDescription.DC}
      </S.ButtonDirection>
    </S.DirectionControl>
  );
};

export default ContentItem;
